var React = require('react');

function IsaacChukwukaLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M38 175L75 229.808V175H38Z","fill":"#EFEFEF","key":0}),React.createElement("rect",{"width":"75","height":"83.6538","fill":"#EFEFEF","key":1}),React.createElement("rect",{"y":"103.846","width":"75","height":"72.1154","fill":"#EFEFEF","key":2})]);
}

IsaacChukwukaLogo.defaultProps = {"width":"75","height":"230","viewBox":"0 0 75 230","fill":"none"};

module.exports = IsaacChukwukaLogo;

IsaacChukwukaLogo.default = IsaacChukwukaLogo;
